import { useQuery } from 'react-query'
import { getTaskTemplatesList } from '../../../core/_requests'

export function useGetTaskTemplates() {
  return useQuery(
    'task-templates-list',
    async () => (await getTaskTemplatesList('')).data,
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: true,
    }
  )
}